import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '日韩大片在线观看',
    url: 'https://rihan-dapian.com',
    description: '最新最全日韩大片在线观看平台，涵盖日本电影、韩国电影、日韩剧场版等精品内容。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <footer className="bg-background-900 text-foreground-200">
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-line text-white text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-white">日韩大片</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汇聚最新、最热、最全的日韩大片资源，涵盖日本电影、韩国电影、日韩剧场版等精品内容，高清画质，每日更新。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">电影分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#featured" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门推荐</a>
              </li>
              <li>
                <a href="#latest" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新上映</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-400"></i>
                </span>
                contact@rihan-dapian.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-primary-400"></i>
                </span>
                400-888-9999
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-primary-400"></i>
                </span>
                北京市朝阳区
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 日韩大片在线观看。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}